import React, { Component, Fragment } from "react";
import Breadcrumbs from "../../../utilities/breadcrumbs";
import { Button, Tab, Tabs } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import i18n from "../../../../i18n";
import Select2 from "../../../utilities/Form/Select2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faFileExcel, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import cookieManager from "../../../../utils/cookieManager";
import Loading from "../../../utilities/Loading";
import DatePickerCustom from "../../../utilities/Form/datepicker";
import moment from "moment/moment";
import TextArea from "../../../utilities/Form/TextArea";
import LabelActive from "../../../utilities/Status/active";
import Table from "../../../utilities/table";
import { StatusActive } from "../../../utilities/Const/StatusActive";
const MySwal = withReactContent(Swal);
export class Closebook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      date: new Date(),
      description: '',
      search: {
        limit: 10,
      },
      monthList: [
        { value: '01', label: i18n.t('January') },
        { value: '02', label: i18n.t('February') },
        { value: '03', label: i18n.t('March') },
        { value: '04', label: i18n.t('April') },
        { value: '05', label: i18n.t('May') },
        { value: '06', label: i18n.t('June') },
        { value: '07', label: i18n.t('July') },
        { value: '08', label: i18n.t('August') },
        { value: '09', label: i18n.t('September') },
        { value: '10', label: i18n.t('October') },
        { value: '11', label: i18n.t('November') },
        { value: '12', label: i18n.t('December') },
      ],
      monthValue: null,
      monthText: i18n.t("Select Month"),
      yearList: [],
      yearText: i18n.t("Select Year"),
      yearValue: null,
      month: null,
      year: null,
      submit:false,
      breadcrumbs: [
        { link: process.env.APP_URL, title: i18n.t("Home"), class: " text-gray-600" },
        { link: null, title: i18n.t("Accounting"), class: " text-gray-600" },
        { link: null, title: i18n.t("Closebook"), class: " text-gray-500" },
      ],
       column: [
        {
          key: "date_format",
          filter: { active: true, type: "Date", data: null },
          title: i18n.t("Date"),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
          sortable:true
        },
        {
          key: "description",
          filter: { active: true, type: "Text", data: null },
          title: i18n.t("Description"),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
          sortable:true
        },
        {
          key: "status",
          filter: {
            active: true,
            type: "Select",
            data: StatusActive,
          },
          title: i18n.t("Status"),
          type: "component",
          tHclass: "min-w-125px",
          tdClass: "",
          component:(data,column)=>{
                return <LabelActive value={data[column.key]} />
          }
        },
        {
          key: "createdAt",
          filter: { active: false, type: "Select", data: null },
          title: i18n.t("Created At"),
          type: "custom",
          tHclass: "text-center min-w-125px",
          tdClass: "",
        },
        {
          key: "updatedAt",
          filter: { active: false, type: "Select", data: null },
          title: i18n.t("Updated At"),
          type: "custom",
          tHclass: "text-center min-w-125px",
          tdClass: "",
        },
        // {
        //   key: "id",
        //   filter: {
        //     active: false,
        //   },
        //   title: i18n.t("Action"),
        //   type: "action",
        //   tHclass: "text-center min-w-150px",
        //   tdClass: "text-center",
        //   form:'icon',
        //   buttons: [
        //     {
        //       key: "id",
        //       btnText: i18n.t("Edit"),
        //       visible: {
        //         key: "status",
        //         params: [],
        //         function: (id, params) => {
        //           const {authUser}=this.props
        //           if(Object.keys(authUser).length >0 && authUser.userAccess!= undefined){
        //             let route=authUser.userAccess.route
        //             if(route.includes('Branch Update')){
        //               return true
        //             }
        //           }
        //           return false;
        //         },
        //       },
        //       btnFunction: (data, column) => {
        //         this.updateData(data);
        //       },
        //       bthClass: "btn btn-warning",
        //     },
        //     {
        //       key: "id",
        //       btnText: i18n.t("Delete"),
        //       visible: {
        //         key: "status",
        //         params: [],
        //         function: (id, params) => {
        //           const {authUser}=this.props
        //           if(Object.keys(authUser).length >0 && authUser.userAccess!= undefined){
        //             let route=authUser.userAccess.route
        //             if(route.includes('Branch Delete')){
        //               return true
        //             }
        //           }
        //           return false;
        //         },
        //       },
        //       btnFunction: (data, column) => {
        //         this.deleteData(data);
        //       },
        //       bthClass: "btn btn-danger",
        //     },
            
        //   ],
        // },
      ],
      isProcessingData:false
    };

    this.handlerSelect = this.handlerSelect.bind(this);
    this.handler = this.handler.bind(this);
    this.handlerDateTime = this.handlerDateTime.bind(this);
    this.runSearch = this.runSearch.bind(this);
  }

  handlerSelect(e, name, currentState) {
    var key = name
    var value = null
    if (e != null) {
      value = e.value
    }
    this.setState({
      [key]: value,
      [currentState]: e
    }
    )
  }

  alertHandler(title, message, icon, i) {
    Swal.fire({
      title: title,
      html: message,
      icon: icon,
    });
  }

  runSearch(value) {
    this.state.submit = false;
    this.props.search(value);
  }
  renderLoading() {
    Swal.fire({
      title: 'Loading',
      width: "200px",
      heightAuto: true
    });
    Swal.showLoading();
  }

 renderError(name) {
    const { isError, errorMessage } = this.props
    var value = ''
    if (isError) {
      if (errorMessage[name] != undefined) {
        value = errorMessage[name][0]
      }
      Swal.close();
    }
    return value;
  }
  renderYear(){
    const {cutoff}=this.props
    const startYear = new Date(cutoff).getFullYear(); // Date string in ISO format
    const currentYear = new Date().getFullYear();
    const years=[];
    for(let year=startYear;year <= currentYear;year++){
        years.push({label:year,value:year})
    }
    return years
  }

  renderMonth(){
    const {cutoff}=this.props
    const startDate = new Date(cutoff); // Date string in ISO format
    const startYear = startDate.getFullYear(); // Date string in ISO format
    const selectedYear = this.state.year;
    const currentYear = new Date().getFullYear();
    let monthsFiltered = [];

    if(selectedYear){
        if (selectedYear === startYear) {
            const startMonth=startDate.getMonth()
            monthsFiltered = this.state.monthList.slice(startMonth); 
        } else if (selectedYear === currentYear) {
            const endMonth=new Date().getMonth()
            monthsFiltered = this.state.monthList.slice(0, endMonth + 1);
        } else if (selectedYear !== currentYear) {
            monthsFiltered = this.state.monthList;
        }
    }

    let check=monthsFiltered.filter((m)=>m.value==this.state.month)
    if(check.length ==0){
        this.state.month=null
        this.state.monthValue=null
    }

    return monthsFiltered
  }

  process(){
    const params={
      year:this.state.year,
      month:this.state.month
    }
    this.props.process(params)
  }

  open(){
    const params={
      date:moment(this.state.date).format('YYYY-MM-DD'),
      description:this.state.description,
    }
    this.props.open(params)
  }

  handlerDateTime(e, name) {
    var key = name;
    var value = e;
    this.setState({
      [key]: value,
    });
  }

  handler(e) {
    var key = e.target.name;
    var value = e.target.value;
    this.setState({
      [key]: value,
    });
  }

  renderTab() {
    const {isProcessing,processText,isProcessingData,data}=this.props
    return (
      <Tabs
        unmountOnExit
        defaultActiveKey="closebook"
        id="closebook"
        className="mb-3"
      >
        <Tab eventKey="closebook" title={i18n.t("Closebook")}>
          <React.Fragment>
              <div className="row">
                <div className="col-md-4 mt-3">
                  <Select2
                    isClearable={true}
                    name={"year"}
                    required={true}
                    size={4}
                    onChange={async (e) => {
                      await this.handlerSelect(e, "year", "yearValue");
                    }}
                    options={this.renderYear()}
                    title={i18n.t("Year")}
                    value={this.state.yearValue}
                    placeholder={this.state.yearText}
                  />
                  <div className="fv-plugins-message-container invalid-feedback">
                    {this.renderError('year')}
                  </div>
                </div>
                <div className="col-md-4 mt-3">
                  <Select2
                    isClearable={true}
                    name={"month"}
                    required={true}
                    size={4}
                    onChange={async (e) => {
                      await this.handlerSelect(e, "month", "monthValue");
                    }}
                    options={this.renderMonth()}
                    title={i18n.t("Month")}
                    value={this.state.monthValue}
                    placeholder={this.state.monthText}
                  />
                  <div className="fv-plugins-message-container invalid-feedback">
                    {this.renderError('month')}
                  </div>
                </div>
              </div>
              <div className="row">
                {isProcessing ?  <div className="col-md-12 mt-3">
                  {processText}
                  <div className="progress">
                    <div className="progress-bar progress-bar-striped bg-primary" role="progressbar" style={{width: "100%"}} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </div>
                :
                <div className="col-md-6 mt-3">
                <Button
                disabled={(this.state.month && this.state.year)?false:true}
                onClick={async (e) => {
                    this.process()
                }}
                  variant="success" className="btn btn-md btn btn-primary m-1 ">
                   {i18n.t("Closebook")}
                </Button>
              </div>
                }
               
               
              </div>
          </React.Fragment>
        </Tab>
        <Tab eventKey="open" title={i18n.t("Open Closebook")}>
          <React.Fragment>
              <div className="row">
                <div className="col-md-2">
                  <DatePickerCustom
                    name={"date"}
                    title={i18n.t("Date")}
                    required
                    selected={this.state.date}
                    onChange={async (e) => {
                      await this.handlerDateTime(e, "date");
                    }}
                    startDay={0}
                    autoComplete={"off"}
                    dateFormat="dd MMM yyyy"
                    endDate={new Date()}
                    className="form-control form-control-sm"
                  />
                  </div>
                  <TextArea
                    name={"description"}
                    required={true}
                    title={i18n.t("Description")}
                    value={this.state.description}
                    handler={this.handler}
                  />
              </div>
              <div className="row">
                {isProcessing ?  <div className="col-md-12 mt-3">
                  {processText}
                  <div className="progress">
                    <div className="progress-bar progress-bar-striped bg-primary" role="progressbar" style={{width: "100%"}} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </div>
                :
                <div className="d-flex gap-5 col-md-6 mt-3">
                <Button
                  disabled={(this.state.date)?false:true}
                  onClick={async (e) => {
                      this.open()
                  }}
                    variant="success" className="btn btn-md btn btn-primary m-1 ">
                   {i18n.t("Open Closebook")}
                </Button>
                {/* <Button
                  disabled={(this.state.date)?false:true}
                  onClick={async (e) => {
                      this.open()
                  }}
                    variant="success" className="btn btn-md btn btn-primary m-1 ">
                   {i18n.t("Open Closebook")}
                </Button> */}
              </div>
                }
              </div>
              <Table
                data={data}
                tools={false}
                filterSearch={true}
                column={this.state.column}
                searchData={this.state.search}
                runSearch={this.runSearch}
                deleteData={()=>{}}
                updateData={()=>{}}
                isProcessing={isProcessingData}
                defaultSort={{name:'asc'}}
              />
          </React.Fragment>
        </Tab>
      </Tabs>
    );
  }
  render() {
    return (
      <div id="invoice-page">
        <Breadcrumbs url={this.state.breadcrumbs} tools={false} />
        <div
          id="kt_content_container"
          className="d-flex flex-column-fluid align-items-start container-fluid"
        >
          <div className="content flex-row-fluid" id="kt_content">
            <div className="card">
              <div className="card-body pt-8">{this.renderTab()}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Closebook;
